import script from "./visionUniv2.vue?vue&type=script&setup=true&lang=js"
export * from "./visionUniv2.vue?vue&type=script&setup=true&lang=js"

import "./visionUniv2.vue?vue&type=style&index=0&id=7e548b35&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e548b35"]])

export default __exports__